// extracted by mini-css-extract-plugin
module.exports = {"PageLearn":"PageLearn___2y4va"};